<div class="service-search-container">
  <div class="service-search-box">
    <input
      type="text"
      [(ngModel)]="searchText"
      (input)="onSearchInput(searchText)"
      (focus)="onFocus()"
      [placeholder]="placeholder"
      [disabled]="disabled"
      class="service-search-input"
    />
    <button
      type="button"
      *ngIf="selectedService"
      (click)="clearSelection()"
      class="btn-clear-service"
      title="Clear selection"
      [disabled]="disabled"
    >
      ×
    </button>
  </div>

  <!-- Service Dropdown -->
  <div class="service-dropdown" *ngIf="showDropdown && !disabled">
    <div class="dropdown-loading" *ngIf="isSearching">
      <div class="spinner-small"></div>
      Searching services...
    </div>

    <div class="dropdown-hint" *ngIf="!isSearching && (!searchText || searchText.length < minSearchLength)">
      Type at least {{ minSearchLength }} characters to search
    </div>

    <div *ngIf="!isSearching && searchText.length >= minSearchLength">
      <div class="service-list" *ngIf="filteredServices.length > 0">
        <div
          class="service-item"
          *ngFor="let service of filteredServices"
          (click)="selectService(service)"
        >
          <div class="service-name">{{ service.displayName }}</div>
          <div class="service-meta">
            <span class="service-category">{{ getCategoryLabel(service.category) }}</span>
            <span class="service-app" *ngIf="service.appId && service.appName">
              {{ service.appName }}
            </span>
            <span class="service-app" *ngIf="!service.appId">
              Global
            </span>
            <span class="service-price">{{ formatCurrency(service.price) }}</span>
          </div>
        </div>
      </div>

      <div class="dropdown-empty" *ngIf="filteredServices.length === 0">
        No services found
      </div>
    </div>
  </div>
</div>
